<script setup lang="ts">
const { LocalConfigurationStore } = stores()
const seo = LocalConfigurationStore.value?.seo
const code = useRouteParams<string | null>('code', null, {
  route: useRoute(),
  router: useRouter(),
})

const currentMetaTags = computed(() => {
  if (code.value) return seo?.find((s) => s.code === code.value)
  else return seo?.find((s) => s.code === 'main')
})
useSeoMeta(currentMetaTags.value ?? {})
</script>

<template>
  <div />
</template>
